export const checkboxLabelStyle = {
	mx: 1,
	'.MuiFormControlLabel-label': {
		fontSize: '12px', // Set the font size dynamically
	},
}

export const inlineSelect = {
	mx: '4px',
	'.MuiSelect-select': {
		fontSize: '14px',
		py: '4px',
	},
}

export const inlineTextfield = {
	mx: '4px',
	fontSize: '14px',
	input: {
		fontSize: '14px',
		py: '6px',
	},
	width: '150px',
}
